import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import './OfflineTrailersGrid.scss';
import {
    ClientSideRowModelModule,
    ModuleRegistry,
    themeMaterial,
} from 'ag-grid-enterprise';
import { OfflineTrailersGridLogic } from './OfflineTrailersGrid';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

function OfflineTrailersGrid() {
    const {
        gridConfig,
        containerStyle,
        gridStyle,
        loading,
        overlayComponentSelector,
    } = OfflineTrailersGridLogic();

    return (
        <div className='offline-trailers-grid-wrapper'>
            <div className='header'><h2>Offline Trailers</h2></div>
            <div style={containerStyle}>
                <div style={gridStyle}>
                    <div className='offline-trailers-grid'>
                        <AgGridReact
                            loading={loading}
                            overlayComponentSelector={overlayComponentSelector}
                            domLayout={'autoHeight'}
                            theme={themeMaterial}
                            rowData={gridConfig.rowData}
                            columnDefs={gridConfig.columnDefs}
                            defaultColDef={{ resizable: true, sortable: true, filter: true }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OfflineTrailersGrid
